import type { CacheStorageOptions } from '@/shared/lib/hooks/use-cache-storage';
import { HITypesAPI } from '@/entities/monitoring/hi';
import { useCacheStorage } from '@/shared/lib/hooks/use-cache-storage';
import { HIType } from '@/entities/monitoring/hi';
import { pick } from 'lodash';
import { useMemo } from 'react';

type HITypeListItem = Pick<HIType, 'id' | 'name' | 'label' | 'description'>;

export const hiTypesQueryConfig: CacheStorageOptions<HITypeListItem[]> = {
  meta: { cacheStorageEvent: 'HIT' },
  queryKey: ['hi-type-list'],
  queryFn: ({ signal }) =>
    HITypesAPI.getTypesList({ signal, timeout: 15000 }).then((res) =>
      (Array.isArray(res?.data) ? res.data : ([] as HIType[])).map((x) =>
        pick(x, ['id', 'name', 'label', 'description']),
      ),
    ),
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  cacheTime: Infinity,
};
export const useHITypeListStorage = () => {
  return useCacheStorage<HITypeListItem[]>({
    queryConfig: hiTypesQueryConfig,
  });
};

export const useHITypesMap = () => {
  const { data = [], ...rest } = useHITypeListStorage();
  const memoizedData = useMemo(
    () => new Map(data.map((el) => [el.name, el])),
    [data],
  );
  return useMemo(() => ({ ...rest, data: memoizedData }), [memoizedData, rest]);
};